import React from 'react';
import { TAG } from 'shared/constants';
import usePiggyBankWidget from 'shared/screens/PiggyBank/hooks/usePiggyBankWidget';
import styled from 'styled-components';
import LazyImage from '../../LazyImage/LazyImage';

export const PiggyBankWidget = React.memo(({ showCoinBalance }) => {
  const { piggyBankAssets, piggyBankIcon, disabledAnimation, handleClick, fillPercentage } = usePiggyBankWidget();
  if (!piggyBankIcon) return null;

  return (
    <Container onClick={handleClick} $showCoinBalance={showCoinBalance}>
      {!disabledAnimation && (
        <PiggyBankIconEmpty
          src={piggyBankAssets?.PIGGY_BANK_ICON_REGULAR_EMPTY}
          tag={TAG.IMG}
          loadingmethod="lazy"
          resize="contain"
        />
      )}

      <PiggyBankIcon
        id="piggy-bank-icon"
        $disabledAnimation={disabledAnimation}
        $fillPercentage={fillPercentage}
        $showCoinBalance={showCoinBalance}
        src={piggyBankIcon}
        tag={TAG.IMG}
        loadingmethod="lazy"
        resize="contain"
      />
    </Container>
  );
});

PiggyBankWidget.displayName = 'PiggyBankWidget';

export default PiggyBankWidget;

const Container = styled.div`
  position: relative;
  width: 6dvw;
  height: 6dvw;
  margin-right: 1.5dvw !important;
  ${({ $showCoinBalance }) => !$showCoinBalance && 'height: 3dvw;'}

  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: 6.5dvw;
    height: 6.5dvw;
    margin-left: -0.3dvw !important;
    ${({ $showCoinBalance }) => !$showCoinBalance && 'height: 3.5dvw;'}
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 7dvw;
    height: 7dvw;
    margin-left: -0.5dvw !important;
    ${({ $showCoinBalance }) => !$showCoinBalance && 'height: 3.5dvw;'}
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 8dvw;
    height: 8dvw;
    margin-left: -0.5dvw !important;
    ${({ $showCoinBalance }) => !$showCoinBalance && 'height: 4.5dvw;'}
  }
`;

const PiggyBankIconEmpty = styled(LazyImage)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

const PiggyBankIcon = styled(LazyImage)`
  width: 100%;
  height: ${({ $showCoinBalance }) => ($showCoinBalance ? 'auto' : '100%')};
  object-fit: contain;
  z-index: 1;
  clip-path: ${({ $fillPercentage, $disabledAnimation }) => {
    if ($disabledAnimation) return 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)';

    const safeFill = Number.isFinite($fillPercentage) ? Math.max(0, Math.min(100, $fillPercentage)) : 0;
    const topEdge = 100 - safeFill;
    return `polygon(0 ${topEdge}%, 100% ${topEdge}%, 100% 100%, 0% 100%)`;
  }};
  transition: ${({ $disabledAnimation }) =>
    $disabledAnimation ? 'none' : 'clip-path 1500ms cubic-bezier(0.4, 0, 0.2, 1)'};
`;
